export default "__VITE_ASSET__CKY7i9jn__"